// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.left-panel {
  background: #ffffff;
  border-right: 1px solid #e0e0e0;
  width: 240px;
  height: 100%;
  display: flex;
  flex-direction: column;
  transition: width 0.3s ease;
}
/* Left.css */

.left-panel {
  display: flex;
  flex-direction: column;
  height: 100vh; /* Ensure the panel takes full height */
  overflow: hidden; /* Prevents the whole panel from scrolling */
}

.nav-section {
  flex: 1 1; /* Take up all remaining space */
  display: flex;
  flex-direction: column;
  min-height: 0; /* Critical for nested flex scrolling */
}

.namespace-list {
  flex: 1 1;
  overflow-y: auto; /* Enable vertical scrolling */
  overflow-x: hidden;
  padding-bottom: 20px;
  
  /* Custom Scrollbar (Optional) */
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.1) transparent;
}

/* Ensure items don't shrink */
.namespace-item {
  flex-shrink: 0;
  min-height: 40px; 
}
.panel-header {
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #f0f0f0;
}

.panel-title {
  font-size: 11px;
  font-weight: 800;
  color: #999;
  letter-spacing: 1.5px;
}

.header-actions {
  display: flex;
  gap: 8px;
}

.btn-icon {
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  transition: background 0.2s;
  font-size: 14px;
}

.btn-icon:hover {
  background: #f0f0f0;
}

.section-label {
  padding: 20px 20px 10px;
  font-size: 10px;
  font-weight: 700;
  color: #bbb;
  text-transform: uppercase;
}

.namespace-item {
  padding: 12px 20px;
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 14px;
  font-weight: 500;
}

.namespace-item:hover:not(.active) {
  background-color: #f8f9fa;
  color: #000 !important;
}

.namespace-icon {
  margin-right: 12px;
  font-size: 18px;
}

.namespace-label {
  flex: 1 1;
}
`, "",{"version":3,"sources":["webpack://./src/TractumUI/components/Left/Left.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,2BAA2B;AAC7B;AACA,aAAa;;AAEb;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa,EAAE,uCAAuC;EACtD,gBAAgB,EAAE,4CAA4C;AAChE;;AAEA;EACE,SAAO,EAAE,gCAAgC;EACzC,aAAa;EACb,sBAAsB;EACtB,aAAa,EAAE,uCAAuC;AACxD;;AAEA;EACE,SAAO;EACP,gBAAgB,EAAE,8BAA8B;EAChD,kBAAkB;EAClB,oBAAoB;;EAEpB,gCAAgC;EAChC,qBAAqB;EACrB,qDAAqD;AACvD;;AAEA,8BAA8B;AAC9B;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,SAAO;AACT","sourcesContent":[".left-panel {\n  background: #ffffff;\n  border-right: 1px solid #e0e0e0;\n  width: 240px;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  transition: width 0.3s ease;\n}\n/* Left.css */\n\n.left-panel {\n  display: flex;\n  flex-direction: column;\n  height: 100vh; /* Ensure the panel takes full height */\n  overflow: hidden; /* Prevents the whole panel from scrolling */\n}\n\n.nav-section {\n  flex: 1; /* Take up all remaining space */\n  display: flex;\n  flex-direction: column;\n  min-height: 0; /* Critical for nested flex scrolling */\n}\n\n.namespace-list {\n  flex: 1;\n  overflow-y: auto; /* Enable vertical scrolling */\n  overflow-x: hidden;\n  padding-bottom: 20px;\n  \n  /* Custom Scrollbar (Optional) */\n  scrollbar-width: thin;\n  scrollbar-color: rgba(255, 255, 255, 0.1) transparent;\n}\n\n/* Ensure items don't shrink */\n.namespace-item {\n  flex-shrink: 0;\n  min-height: 40px; \n}\n.panel-header {\n  padding: 15px 20px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.panel-title {\n  font-size: 11px;\n  font-weight: 800;\n  color: #999;\n  letter-spacing: 1.5px;\n}\n\n.header-actions {\n  display: flex;\n  gap: 8px;\n}\n\n.btn-icon {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 4px;\n  border-radius: 4px;\n  transition: background 0.2s;\n  font-size: 14px;\n}\n\n.btn-icon:hover {\n  background: #f0f0f0;\n}\n\n.section-label {\n  padding: 20px 20px 10px;\n  font-size: 10px;\n  font-weight: 700;\n  color: #bbb;\n  text-transform: uppercase;\n}\n\n.namespace-item {\n  padding: 12px 20px;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.namespace-item:hover:not(.active) {\n  background-color: #f8f9fa;\n  color: #000 !important;\n}\n\n.namespace-icon {\n  margin-right: 12px;\n  font-size: 18px;\n}\n\n.namespace-label {\n  flex: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
